/**
 * Locale constants for cause-dashboard.
 *
 * Kept in this dependency-free module (no React/app/env imports) so build-time
 * tooling such as `tools/validate-translations.ts` can read the list without
 * booting the app's runtime module graph (which would load `env.ts`).
 * `useLocale.ts` re-exports these for app consumers.
 */
export const DEFAULT_LOCALE = 'en-US'

/**
 * Locales with full translations for the entire cause-dashboard.
 * When adding a new locale here, ensure a translated `cp.json` exists at
 * `i18n/data/<locale>/cp.json` and the resource is wired in `i18n/resources.ts`.
 */
export const fullyTranslatedLocales = ['fr-CA', 'zh-CN', 'es-ES', 'fr-FR', 'de-DE', 'pt-BR', 'ja-JP'] as const

export const supportedLocales = [DEFAULT_LOCALE, ...fullyTranslatedLocales] as const

export type SupportedLocale = typeof supportedLocales[number]

/**
 * Native language names, shown to users when naming the locale they picked
 * (locale picker, browser-translation warnings).
 */
export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  'en-US': 'English',
  'fr-CA': 'Français (Canada)',
  'fr-FR': 'Français',
  'de-DE': 'Deutsch',
  'es-ES': 'Español',
  'pt-BR': 'Português (Brasil)',
  'ja-JP': '日本語',
  'zh-CN': '简体中文'
}
